import {
  ChangeDetectionStrategy,
  Component,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { PlatformService } from '../../../../../core/services/platform.service';
import { ILandingPostCommentActivityPublic } from '../../interface';
import { LandingPageDataService } from '../../services/landing-post-data.service';
import { LandingPostService } from '../../services/landing-post.service';

@Component({
    selector: 'app-post-comments',
    templateUrl: './post-comments.component.html',
    styleUrl: './post-comments.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PostCommentsComponent {
  lastCommentNumbering = 0;
  isNoMoreComments = signal<boolean>(false);
  isLoading = signal<boolean>(false);

  comments = signal<ILandingPostCommentActivityPublic[]>([]);

  constructor(
    private landingPostService: LandingPostService,
    public landingPageDataService: LandingPageDataService,
    private pt: PlatformService,
  ) {}

  ngOnInit() {
    if (this.pt.isBrowser) {
      this.getComments();
    }
  }

  async getComments() {
    this.isLoading.set(true);
    var res = await this.landingPostService.getComments(
      this.landingPageDataService.details()._id,
      this.lastCommentNumbering,
      this.landingPageDataService.isQrCode(),
    );

    this.isLoading.set(false);

    if (res.result?.length < 5) {
      this.isNoMoreComments.set(true);
    }
    if (res.result?.length == 0) return;

    this.comments.update((comments) => [...comments, ...res.result]);
    this.lastCommentNumbering = res.result[res.result.length - 1].numbering;
  }

  addComment(comment: any) {
    this.comments.update((comments) => [comment, ...comments]);
  }
}
